export const DASHBOARD_PREFS_KEY = "inksight-dashboard-preferences-v1";
export const DASHBOARD_PREFS_EVENT = "inksight-dashboard-preferences-changed";
export const KANBAN_PREFS_KEY = "inksight-kanban-preferences-v1";

export const DASHBOARD_DEFAULT_TILE_COLORS = {
  all_active: "#1e3a8a",
  in_review: "#164e63",
  pending_graphics: "#7c2d12",
  ready_for_submission: "#78350f",
};

export const DASHBOARD_DEFAULT_PHASE_COLORS = {
  awaiting_graphics_approval: "#7c2d12",
  ready_for_submission: "#78350f",
  artwork_submitted: "#1e3a8a",
  pdf_proof: "#164e63",
  swatch: "#7c2d12",
  pilot: "#581c87",
  graphics_complete: "#064e3b",
};

export const loadKanbanColors = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KANBAN_PREFS_KEY) || "{}");
    return {
      ...DASHBOARD_DEFAULT_PHASE_COLORS,
      ...(saved.colors || {}),
    };
  } catch {
    return { ...DASHBOARD_DEFAULT_PHASE_COLORS };
  }
};

export const loadDashboardPreferences = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(DASHBOARD_PREFS_KEY) || "{}");
    return {
      phaseColorSource: saved.phaseColorSource === "custom" ? "custom" : "kanban",
      tileColors: {
        ...DASHBOARD_DEFAULT_TILE_COLORS,
        ...(saved.tileColors || {}),
      },
      phaseColors: {
        ...DASHBOARD_DEFAULT_PHASE_COLORS,
        ...(saved.phaseColors || {}),
      },
    };
  } catch {
    return {
      phaseColorSource: "kanban",
      tileColors: { ...DASHBOARD_DEFAULT_TILE_COLORS },
      phaseColors: { ...DASHBOARD_DEFAULT_PHASE_COLORS },
    };
  }
};

export const saveDashboardPreferences = (preferences) => {
  localStorage.setItem(DASHBOARD_PREFS_KEY, JSON.stringify(preferences));
  window.dispatchEvent(new Event(DASHBOARD_PREFS_EVENT));
};

export const resolveDashboardColors = () => {
  const preferences = loadDashboardPreferences();
  return {
    tileColors: preferences.tileColors,
    phaseColors:
      preferences.phaseColorSource === "custom"
        ? preferences.phaseColors
        : loadKanbanColors(),
  };
};
